<template>
  <div class="client-page">
    <SmallModal />
    <AlertModal />

    <!-- DESKTOP HEADER -->
    <header class="bg-gray-800 hidden lg:block">
      <div class="c-container flex justify-between items-center">
        <div class="logo-container w-auto flex items-center">
          <router-link
            class="logo flex-center gap-2 text-white font-bold"
            v-slot="{ href, navigate }"
            :to="{ name: 'ClientIndex' }"
          >
            <div @click="navigate" :href="href">
              <img src="/assets/images/icons/logo.png" alt="logo" class="h-8" />
            </div>
            <div class="title">FPV</div>
          </router-link>
        </div>

        <div
          class="nav-container central-nav flex flex-wrap justify-center text-center gap-4 flex-1 min-w-[300px]"
        >
          <!-- меню как у тебя сейчас -->
          <div class="relative group menu pointer px-3">
            Правовая и новостная информация
            <div
              class="sub-menu absolute z-50 bg-white shadow-lg mt-2 rounded left-1/2 transform -translate-x-1/2"
            >
              <ul class="py-2">
                <li class="px-4 py-2 text-black hover:bg-gray-100">
                  <router-link
                    :to="{
                      name: 'PageContent',
                      params: { contentType: 'news' },
                    }"
                    >Новости</router-link
                  >
                </li>
                <li class="px-4 py-2 text-black hover:bg-gray-100">
                  <router-link
                    :to="{
                      name: 'PageContent',
                      params: { contentType: 'law' },
                    }"
                    >Законы</router-link
                  >
                </li>
                <li class="px-4 py-2 text-black hover:bg-gray-100">
                  <router-link
                    :to="{
                      name: 'PageContent',
                      params: { contentType: 'science' },
                    }"
                    >Наука</router-link
                  >
                </li>
              </ul>
            </div>
          </div>
          <template v-if="user.role !== 4">
            <div class="relative group menu pointer px-3">
              <router-link
                :to="{ name: 'PageContent', params: { contentType: 'contest' } }"
              >
                Соревнования/Конкурсы/Турниры
              </router-link>
            </div>
          </template>
          <div class="relative group menu pointer px-3">
            <router-link
              :to="{ name: 'ExpertSearch', }"
              >Поиск экспертов</router-link
            >
          </div>
          <template v-if="user.role !== 4">
            <div class="relative group menu pointer px-3">
              <router-link
                :to="{
                  name: 'PageContent',
                  params: { contentType: 'uav_catalog' },
                }"
                >Продукция</router-link
              >
            </div>
            <div class="relative group menu pointer px-3">
              <router-link :to="{ name: 'ClientEducation' }"
                >Онлайн академия</router-link
              >
            </div>
          </template>
        </div>

        <div class="right-nav flex items-center gap-4 whitespace-nowrap">
          <nav class="flex-center fl-start nav">
            <div v-if="userToken">
              <router-link
                v-slot="{ href, navigate }"
                :to="{ name: user.role && user.role.key === 4 ? 'ExperProfieletList' : 'ClientCourses' }"
              >
                <div @click="navigate" :href="href">
                  <div class="relative group">
                    <img 
                      class="header-icon"
                      src="/assets/images/icons/user.png" alt="">
                    <div
                      class="absolute left-1/2 -translate-x-1/2 mt-2 px-3 py-1 bg-gray-900 text-white text-sm rounded shadow-lg opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none whitespace-nowrap z-10"
                      style="top: 100%;"
                    >
                      Личный кабинет
                    </div>
                  </div>
                </div>
              </router-link>
            </div>
            <div>
              <!-- Logout button -->
              <div v-if="userToken" @click="logout" class="cursor-pointer">
                <div class="relative group">
                  <img
                    class="header-icon"
                    src="/assets/images/icons/logout.png" alt="">
                  <div
                    class="absolute left-1/2 -translate-x-1/2 mt-2 px-3 py-1 bg-gray-900 text-white text-sm rounded shadow-lg opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none whitespace-nowrap z-10"
                    style="top: 100%;"
                  >
                    Выйти
                  </div>
                </div>
              </div>
              <!-- Login link -->
              <router-link
                v-else
                :to="{ name: 'ClientLogin' }"
              >
                <div class="relative group">
                  <img
                    class="header-icon"
                    src="/assets/images/icons/log-in.png" alt="">
                  <div
                    class="absolute left-1/2 -translate-x-1/2 mt-2 px-3 py-1 bg-gray-900 text-white text-sm rounded shadow-lg opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none whitespace-nowrap z-10"
                    style="top: 100%;"
                  >
                    Авторизация
                  </div>
                </div>
              </router-link>
            </div>
          </nav>
        </div>
      </div>
    </header>

    <!-- MOBILE HEADER -->
    <header
      class="bg-gray-800 lg:hidden relative"
      :style="{ zIndex: isMenuOpen ? 10000 : 50 }"
    >
      <div class="c-container flex justify-between items-center py-3">
        <!-- Лого -->
        <div class="logo-container flex items-center">
          <router-link
            class="logo flex-center gap-2 text-white font-bold"
            v-slot="{ href, navigate }"
            :to="{ name: 'ClientIndex' }"
          >
            <div @click="navigate" :href="href">
              <img src="/assets/images/icons/logo.png" alt="logo" class="h-8" />
            </div>
            <div class="title">FPV</div>
          </router-link>
        </div>

        <!-- Бургер -->
        <button
          class="text-white text-2xl p-2 z-50 relative"
          @click.stop="isMenuOpen = !isMenuOpen"
        >
          <span v-if="!isMenuOpen">☰</span>
          <span v-else>✖</span>
        </button>
      </div>

      <!-- Фулскрин меню -->
      <transition name="fade">
        <div
          v-if="isMenuOpen"
          style="z-index: 9999;"
          class="fixed inset-0 bg-gray-900 text-white flex flex-col items-center justify-start pt-20 space-y-6 z-[9999]"
        >
          <!-- Крестик закрытия -->
          <button
            @click="isMenuOpen = false"
            class="absolute top-4 right-4 text-white text-3xl focus:outline-none"
          >
            ✖
          </button>

          <!-- Лого -->
          <div class="logo-container flex items-center">
            <router-link
              class="logo flex-center gap-2 text-white font-bold"
              v-slot="{ href, navigate }"
              :to="{ name: 'ClientIndex' }"
              @click.native="isMenuOpen = false"
            >
              <div @click="navigate" :href="href">
                <img
                  src="/assets/images/icons/logo.png"
                  alt="logo"
                  class="h-8"
                />
              </div>
              <div class="title">FPV</div>
            </router-link>
          </div>

          <!-- Навигация -->
          <router-link
            class="text-lg"
            :to="{ name: 'PageContent', params: { contentType: 'news' } }"
            @click.native="isMenuOpen = false"
            >Новости</router-link
          >
          <router-link
            class="text-lg"
            :to="{ name: 'PageContent', params: { contentType: 'law' } }"
            @click.native="isMenuOpen = false"
            >Законы</router-link
          >
          <router-link
            class="text-lg"
            :to="{ name: 'PageContent', params: { contentType: 'science' } }"
            @click.native="isMenuOpen = false"
            >Наука</router-link
          >
          <router-link
            class="text-lg"
            :to="{ name: 'PageContent', params: { contentType: 'contest' } }"
            @click.native="isMenuOpen = false"
            >Соревнования/Конкурсы</router-link
          >
          <router-link
            class="text-lg"
            :to="{ name: 'ExpertSearch' }"
            @click.native="isMenuOpen = false"
          >
            Поиск экспертов
          </router-link>
          <router-link
            class="text-lg"
            :to="{ name: 'ClientCourses' }"
            @click.native="isMenuOpen = false"
            >Обучение</router-link
          >
          <router-link
            class="text-lg"
            :to="{
              name: 'PageContent',
              params: { contentType: 'uav_catalog' },
            }"
            @click.native="isMenuOpen = false"
            >Продукция</router-link
          >
          <router-link
            class="text-lg"
            :to="{ name: 'ClientEducation' }"
            @click.native="isMenuOpen = false"
            >Онлайн академия</router-link
          >

          <!-- Личный кабинет -->
          <router-link
            class="text-lg flex items-center gap-2"
            :to="{ name: 'ClientCourses' }"
            v-if="userToken"
            @click.native="isMenuOpen = false"
          >
            Личный кабинет
          </router-link>

          <!-- Выйти / Авторизация -->
          <a
            v-if="userToken"
            class="text-lg flex items-center gap-2 cursor-pointer"
            @click="isMenuOpen = false; logout()"
          >
            Выйти
          </a>
          <router-link
            v-else
            class="text-lg flex items-center gap-2"
            :to="{ name: 'ClientLogin' }"
            @click.native="isMenuOpen = false"
          >
            Авторизация
          </router-link>
        </div>
      </transition>
    </header>

    <router-view />

<footer class="bg-gray-900 text-gray-200 mt-10">
  <div class="c-container items-start py-8 gap-8 md:grid-cols-1 grid-cols-3  mob-col">
    <!-- Контакты -->
    <div class="text-left">
      <h3 class="text-lg font-semibold mb-3">Контактные данные</h3>
      <address class="not-italic text-sm leading-6">
        ТОО «Research &amp; Development центр «Казахстан инжиниринг»<br />
        БИН 100140003741<br />
        ИИК KZ67551Z600000763046<br />
        АО «Фридом Банк Казахстан»<br />
        БИК KSNVKZKA<br />
        Республика Казахстан, г. Астана, ул. Ауезова, д. 2, н. п. 1 <br />
        Email: <a href="mailto:info@rdke.kz">info@rdke.kz</a>
      </address>

      <!-- Логотип -->
      <div class="mt-3">
        <div class="flex md:justify-start mb-4 items-start">
          <img
            src="/assets/images/icons/visa-logo.png"
            alt="VISA"
            class="h-10 object-contain rounded bg-white p-2"
          />
        </div>
      </div>
    </div>

    <!-- Главный бухгалтер -->
    <div class="flex flex-col items-start md:items-center justify-start">
      <h3 class="text-lg font-semibold mb-3 md:text-center">Контактное лицо</h3>
      <p class="text-sm leading-6 text-left md:text-center">
        Сотрудник, ответственный за общение с клиентами <br />
        главный бухгалтер <br />
        Турганбаев Шадияр Исабекович
      </p>
      <a
        class="underline hover:no-underline mt-2 text-left md:text-center"
        href="tel:+77172322139"
      >
        +7 7172 322139 (доб. 114)
      </a>
    </div>

    <!-- Политики и инфо -->
    <div class="text-left md:text-right">
      <h3 class="text-lg font-semibold mb-3">Информация</h3>
      <ul class="space-y-2 text-sm">
        <li>
          <router-link
            class="underline hover:no-underline"
            :to="{ name: 'PrivacyPolicy' }"
          >
            Политика конфиденциальности
          </router-link>
        </li>
        <li>
          <router-link
            class="underline hover:no-underline"
            :to="{ name: 'PaymentProcedure' }"
          >
          Правила оплаты и возврат
          </router-link>
        </li>
        <li>
          <router-link
            class="underline hover:no-underline"
            :to="{ name: 'Offer' }"
          >
            Оферта
          </router-link>
        </li>
      </ul>
    </div>
  </div>

  <div class="border-t border-gray-800">
    <div class="c-container py-4 text-xs text-gray-400">
      {{ date.getFullYear() }} © Все права защищены
    </div>
  </div>
</footer>
  </div>
</template>

<script>
import SmallModal from "@/components/Modals/SmallModal.vue";
import AlertModal from "@/components/Modals/AlertModal.vue";
import { mapState, mapMutations } from "vuex";

export default {
  components: { SmallModal, AlertModal },
  data() {
    return {
      date: new Date(),
      isMenuOpen: false,
      userToken: localStorage.getItem("user_token") !== null,
    };
  },
  computed: {
    ...mapState(["user"]),
  },
  watch: {
    $route() {
      this.userToken = localStorage.getItem("user_token") !== null;
    },
  },
  methods: {
    ...mapMutations(["deleteUser"]),
    logout() {
      localStorage.removeItem("user_token");
      localStorage.removeItem("user_token_expired");
      this.userToken = false;
      this.deleteUser();
      this.$router.push({ name: "ClientLogin" });
    },
  },
};
</script>

<style scoped>
.header-icon {
  width: 24px;
  height: 24px;
  filter: invert(1) brightness(2);
}
.client-page {
  position: relative;
  background-size: cver;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  z-index: 9999;
}
.c-container {
  margin: 0 auto;
  padding: 0 20px;
}
.flex-center {
  display: flex;
  align-items: center;
  justify-content: center;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>